import { Component, Input } from '@angular/core';
import {
  ReferenceEntity
} from 'src/app/static-data/models/interfaces/static-data';

@Component({
  selector: 'app-dc-reference-display',
  templateUrl: './dc-reference-display.component.html',
  styleUrls: ['./dc-reference-display.component.scss'],
})
export class DcReferenceDisplayComponent {
  @Input() label: string;
  @Input() items?: ReferenceEntity[] = [];
}
